// components/DataBoundary.jsx
'use client'
import { Suspense } from 'react'
import ErrorBoundary from '@/components/ErrorBoundary'

export default function DataBoundary({
    children,
    loadingFallback,
    errorFallback,
    retryLimit = 3
}) {
    return (
        <ErrorBoundary
            fallback={errorFallback}
            retryLimit={retryLimit}
        >
            <Suspense fallback={loadingFallback || <DefaultLoader />}>
                {children}
            </Suspense>
        </ErrorBoundary>
    )
}

const DefaultLoader = () => (
    <div className="loading-spinner">
        <div className="spinner"></div>
        <p>资源加载中...</p>
    </div>
)